<template>
  <!-- <div class="wap-app" id="app" v-if="!isPc">
    <img src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap.jpg" alt="">
  </div> -->
  <div id="app" :class="`${ En ? 'en-wrapper' : 'pc-wrapper' } ${ ExhibitDetail.uuid ? 'app-exhibitDetail' : '' }`">
      <bigIcon></bigIcon>
      <heads v-if="showHomeShening" v-show="(!show && isPc) || !isPc" :headOpacity="headOpacity"></heads>
      <heads v-else :headOpacity="headOpacity"></heads>
      <div id="app-container" :style="{ height: showPcShenmingInit ? 192000/clientWidth + 'vh' : 'auto', overflow: showPcShenmingInit ? 'hidden' : 'visible' }">
        <zhanlan_top v-if="ExhibitDetail.uuid"></zhanlan_top>
        <transition name="fade">
          <!-- <shenming v-if="isPc && showHomeShening" :showPcShenming="showPcShenming"><heads :showPcShenming="show"></heads></shenming> -->
        </transition>
        <keep-alive>
          <router-view v-if="!$route.meta.nokeep" />
        </keep-alive>
        <router-view v-if="$route.meta.nokeep" />
        <foots></foots>
      </div>
      <!-- <shenmingWap v-if="!isPc && showHomeShening"></shenmingWap> -->
      <systemMask v-if="$store.state.showSystem && !isPc"></systemMask>
      <div class="share-mask" @click="closeShare" v-if="showShare"></div>
      <vshare v-show="showShare" ref="vshare" :vshareConfig="vshareConfig"></vshare>
      <cookie v-if="$route.path == '/' || $route.path == '/home'" :rate="rate"></cookie>
  </div>
</template>

<script>
import protal from "@/api/protal";
import { mapState } from "vuex";
import vshare from 'vshare'
import bigIcon from "./components/bigIcon.vue"
import shenming from "./components/shenming.vue"
import shenmingWap from "./components/shenmingWap.vue"
import systemMask from './pages/system/index.vue'
import zhanlan_top from './components/zhanlan_top.vue';
import cookie from './components/cookie.vue';
export default {
  name: "App",
  components: {
    bigIcon,
    shenming,
    shenmingWap,
    systemMask,
    zhanlan_top,
    vshare,
    cookie
  },
  data() {
    return {
      clientWidth: 0,
      showPcShenming: false,
      show: false,
      showPcShenmingInit: false,
      showHomeShening: false,
      vshareConfig: {
        shareList: [
          'weixin',
          'tsina',
        ],
        common: { //此处放置通用设置
          bdUrl: location.href,
        },
        share : [{
            //此处放置分享按钮设置
            bdSize: 40
          }
        ],
      },
      rate: 1,
      headOpacity: 1,
      timer: null
    }
  },
  created() {
    this.showHomeShening = location.pathname === '/home' || location.pathname === '/'
    setTimeout(() => {
      this.showPcShenmingInit = false
    }, 800)
    setTimeout(() => {
      this.showPcShenming = false
    }, 5000)
    setTimeout(() => {
      this.show = false
    }, 6000)
    if (this.$route.path == '/home') {
      this.$store.commit('setHeadIndex', 0)
    } else {
      this.$store.commit('setHeadIndex', window.localStorage.getItem('headIndex') || 0)
    }
    this.$store.commit('setLeftIndex', window.localStorage.getItem('leftIndex') || 0)
    this.$store.commit('setExhibitDetail', window.localStorage.getItem('ExhibitDetail') ? JSON.parse(window.localStorage.getItem('ExhibitDetail')) : {})
    this.$store.commit('setHeadList', window.localStorage.getItem('headList') ? JSON.parse(window.localStorage.getItem('headList')) : [])
    this.$store.commit('setPageName', window.localStorage.getItem('pageName') ? JSON.parse(window.localStorage.getItem('pageName')) : [])
    this.$store.commit('setFunctionModule', window.localStorage.getItem('FunctionModule') ? JSON.parse(window.localStorage.getItem('FunctionModule')) : [])
  },
  computed: {
    ...mapState({
			ExhibitDetail: state => state.ExhibitDetail,
      showShare: state => state.showShare
		})
  },
  watch: {
    ExhibitDetail: {
      handler(v) {
        this.$nextTick(() => {
          this.windowScale()
        })
      },
      deep: true
    }
  },
  mounted() {
    localStorage.setItem('scrollTops', null)
    window.scrollTo(0, 0)
    const that = this
    this.windowScale()
    window.addEventListener('resize', () => {
      this.windowScale()
    })
    const clientHeight = document.documentElement.clientHeight
    window.addEventListener('scroll', e => {
      const scrollTop = document.documentElement.scrollTop
      this.$store.commit('setTop', scrollTop)
      this.controlHead(clientHeight, scrollTop)
    })
    window.addEventListener("popstate", function(e) { 
      const pageIsExhibit = localStorage.getItem('pageIsExhibit')
      if (pageIsExhibit && JSON.parse(pageIsExhibit)[JSON.parse(pageIsExhibit).length - 2] && JSON.parse(pageIsExhibit)[JSON.parse(pageIsExhibit).length - 2].flag === false && that.$store.state.ExhibitDetail.uuid) {
        that.$store.commit('setExhibitDetail', {})
        that.$store.commit('setLeftIndex', JSON.parse(pageIsExhibit)[JSON.parse(pageIsExhibit).length - 2].leftIndex)
        that.$store.commit('setHeadIndex', JSON.parse(pageIsExhibit)[JSON.parse(pageIsExhibit).length - 2].headIndex)
        localStorage.setItem('popstate', '1')
      }

      if (JSON.parse(pageIsExhibit)) {
        const arr = JSON.parse(pageIsExhibit)
        arr.pop()
        localStorage.setItem('pageIsExhibit', JSON.stringify(arr))
      }
    }, false);
  },
  methods: {
    controlHead(clientHeight, scrollTop) {
      console.log('屏幕高度', clientHeight)
      console.log('滚动条位置', scrollTop)
      clearTimeout(this.timer)
      this.headOpacity = 1
      if (scrollTop > clientHeight) {
        this.timer = setTimeout(() => {
          this.headOpacity = 0
        }, 1500)
      }
    },
    closeShare() {
      this.$store.commit('setshowShare', false)
    },
    windowScale() {
      this.clientWidth = document.documentElement.clientWidth
      this.rate = this.clientWidth/1920
      if (this.clientWidth > 768) {
        const appContainer = document.getElementById('app-container')
        appContainer.style.transform = `scale(${this.rate})`
        appContainer.style.width = 1920 + 'px'
        appContainer.style.transformOrigin = 'left top'

        const head = document.getElementById('header')
        head.style.transform = `scale(${this.rate})`
        head.style.width = 1920 + 'px'
        head.style.transformOrigin = 'left top'
      }
    }
  }
};

</script>

<style lang="less">
@import url('~@/assets/font/font.less');
@import url('~@/assets/css/reset.less');
@import url('~@/assets/css/index.less');
</style>



// WEBPACK FOOTER //
// src/App.vue